// @ts-nocheck
/**
 * NPCトレードシステム - 定数定義
 */

// ========================================
// オファー種類の確率分布
// ========================================

export const OFFER_TYPE_RATES = {
  equal: 0.30,       // 等価交換
  profitable: 0.25,  // お得交換
  loss: 0.15,        // 損交換
  attribute: 0.15,   // 属性変換
  rare: 0.10,        // レア交換
  gamble: 0.05,      // ギャンブル
};

// ========================================
// 「渡すカード」の生成方式割合
// ========================================

export const GIVE_TYPE_RATES = {
  specific: 0.70,    // 具体的指定（所持カードから）
  condition: 0.30,   // 条件指定（属性/レアリティ等）
};

// ========================================
// 価値比率の範囲
// ========================================

export const VALUE_RATIO_RANGES = {
  equal: { min: 0.9, max: 1.1 },
  profitable: { min: 1.2, max: 1.8 },
  loss: { min: 0.5, max: 0.8 },
  attribute: { min: 0.9, max: 1.2 },
  rare: { min: 1.0, max: 1.5 },
};

// ========================================
// ギャンブル結果の確率
// ========================================

export const GAMBLE_RESULTS = {
  jackpot: { rate: 0.10, ratio: { min: 2.0, max: 3.0 }, label: '大当たり' },
  win: { rate: 0.30, ratio: { min: 1.2, max: 1.5 }, label: '当たり' },
  normal: { rate: 0.35, ratio: { min: 0.8, max: 1.2 }, label: '普通' },
  lose: { rate: 0.20, ratio: { min: 0.3, max: 0.6 }, label: 'ハズレ' },
  bigLose: { rate: 0.05, ratio: { min: 0.1, max: 0.3 }, label: '大ハズレ' },
};

// ========================================
// 予約システム定数
// ========================================

export const RESERVATION_CONFIG = {
  depositRate: 0.10,       // 手付金割合（10%）
  maxDuration: 7,          // 最大有効期間（日）
  maxReservations: 1,      // 同時予約可能数
};

// ========================================
// オファー生成設定
// ========================================

export const OFFER_CONFIG = {
  minOffers: 3,            // 最小オファー数
  maxOffers: 5,            // 最大オファー数
  minCardsPerOffer: 1,     // オファーあたり最小カード枚数
  maxCardsPerOffer: 5,     // オファーあたり最大カード枚数
};

// ========================================
// 条件指定パターン
// ========================================

export const CONDITION_PATTERNS = [
  // 属性指定
  { type: 'attribute', weight: 0.35 },
  // レアリティ指定
  { type: 'rarity', weight: 0.30 },
  // カテゴリ指定
  { type: 'category', weight: 0.20 },
  // 任意（レアリティのみ）
  { type: 'any', weight: 0.15 },
];

// ========================================
// レアリティ順序（価値計算用）
// ========================================

export const RARITY_ORDER = ['C', 'UC', 'R', 'SR', 'UR', 'HR', 'SEC', 'ALT', 'SP', 'GR'];

// ========================================
// 属性リスト
// ========================================

export const ATTRIBUTES = ['炎', '水', '光', '闇', '原始', '未来'];

// ========================================
// オファータイプのラベル
// ========================================

export const OFFER_TYPE_LABELS = {
  equal: '等価交換',
  profitable: 'お得交換',
  loss: '交換',
  attribute: '属性変換',
  rare: 'レア交換',
  gamble: 'ギャンブル',
};

// ========================================
// オファータイプのアイコン
// ========================================

export const OFFER_TYPE_ICONS = {
  equal: '🔄',
  profitable: '⭐',
  loss: '📦',
  attribute: '🔀',
  rare: '💎',
  gamble: '🎲',
};
